import { useEffect } from 'react'

import { Chats } from '../../firebase/collections'

import { isWithinLast30Seconds } from './helpers'

const useChatListenerMessages = ({
  userRole,
  userUniqId,
  userBuildingId,
  dispatchUpdateConversation,
  dispatchAddConversation,
}) => {
  const buildingIdNumber =
    userBuildingId && typeof userBuildingId === 'object' ? userBuildingId.id : userBuildingId

  useEffect(() => {
    if (
      ['PropertyManager', 'ShiftManager', 'Staff', 'Administrator', 'Manager'].includes(userRole)
    ) {
      const unsubscribe = Chats.doc(`${buildingIdNumber}`)
        .collection('channelsWithLastMessage')
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            const channelChangedData = change.doc.data()
            if (change.type === 'modified') {
              dispatchUpdateConversation(channelChangedData)
            } else if (
              change.type === 'added' &&
              isWithinLast30Seconds(channelChangedData.createdAt)
            ) {
              dispatchAddConversation(channelChangedData)
            }
          })
        })

      return () => {
        unsubscribe()
      }
    }
  }, [userUniqId, buildingIdNumber])
}

export default useChatListenerMessages
